import { Component, ComponentInterface, Element, h, Prop, VNode } from '@stencil/core';

import { UniTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({
  tag: 'uni-frame',
  styles: 'iframe {width:100%;border:none;}',
})
export class UniFrameComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) src: string;

  render(): VNode {
    return UniTemplate(
      <iframe scrolling={'no'} src={this.src}>
        <slot />
      </iframe>
    );
  }

  componentDidLoad(): void {
    uniWatermark('pro');

    const contentWindow = this.el.firstElementChild['contentWindow'];

    if (contentWindow) {
      contentWindow.uniResizeObserver = new ResizeObserver((entries) => {
        this.el.firstElementChild['height'] = Math.trunc(entries[0]?.contentRect?.height) + 5;
      });

      contentWindow.addEventListener('load', uniBodyObserve);
    }
  }

  /** No need because window of iframe */
  // disconnectedCallback(): void {
  //   if (this.el.firstElementChild) {
  //     const contentWindow = this.el.firstElementChild['contentWindow'];
  //
  //     contentWindow.removeEventListener('load', uniBodyObserve);
  //     contentWindow.uniResizeObserver?.disconnect();
  //   }
  // }
}

function uniBodyObserve(): void {
  this.uniResizeObserver.observe(this.document.body);
}
